import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Col, Typography, Icon } from "witmeg-ui-system";
import "./LayoutVoucher.scss"
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { getCurrencyFormat, getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../../RestaurantWidget/utilities/helper/helper";
import { addToCart, deleteCartItem, getCartItemsToCartV3, updateCartItemQuantity } from "../../../../RestaurantWidget/utilities/api/restaurantsService";
import deal from "../../../assets/deal.png"
import deleteIc from "../../../assets/trash.svg"

import { setOrderCartItems, setOrderData, setOrderEmpty } from '../../../../../../../../redux/resturantWidgetSlice';
import eye from "../../../assets/eye.svg"
import cart from "../../../assets/cart-white.svg"
import IMAGE_PLACEHOLDER from "../../../assets/images/Images/vouchers-placeholder.jpg"
import DeletePopup from '../../../components/Cart/DeletePopup';
import PreviewPopup from '../../../components/Cart/PreviewPopup';
const LayoutVoucher = ({ data, setCartAlertVisible, menuData, setIsOrderSuccess, setIsItemLoading }) => {
    const [isDeleteItem, setIsDeleteItem] = useState("")
    const [isLoading, setIsLoading] = useState("")
    const [isIncreasing, setIsIncreasing] = useState(false)
    const [isDecreasing, setIsDeccreasing] = useState(false)
    const [selectedVoucher, setSelectedVoucher] = useState(null)
    const [isPrevLoading, setIsPrevLoading] = useState(false)




    const dispatch = useDispatch()
    const restaurantDataState = useSelector((state) => state.resturantData);
    const { currency, orderCartData, voucherData
    } = useSelector((state) => state.resturantData);
    const { companyDetails } = useSelector((state) => state.companyData);
    const currencyFormat = getCurrencyFormat(currency);
    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.DeliveryPrice;
                break;
            case "table":
                priceValue = price?.TablePrice;
                break;
            default:
                priceValue = price?.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };
    const findItemFromCart = (menuItem) => {
        let isAvailable = null
        if (!orderCartData?.Items) {
            return isAvailable
        }
        if (orderCartData?.Items?.length === 0) {
            return isAvailable
        }
        else {
            let found = orderCartData?.Items?.filter((item) => item.CartItemID === menuItem?.MenuItemID)[0]
            isAvailable = found
        }
        return isAvailable

    }
    const updateTotalPrice = (price, quantity) => {
        const createPriceObj = (priceValue, quantity) => ({
            Amount: priceValue * quantity,
            FormattedText: currencyFormat((priceValue * quantity)),
            FormattedAmount: Number(((priceValue * quantity)).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.Delivery.Amount || 0, quantity),
            TakeAway: createPriceObj(price?.TakeAway.Amount || 0, quantity),
            DineIn: createPriceObj(price?.DineIn.Amount || 0, quantity),
            CurrencyCode: "GBP"
        });
        const totalPrice = getPriceData(price, quantity);
        return totalPrice
    }
    const increaseQty = (item) => {
        setIsIncreasing(true)
        setIsItemLoading(item.ID)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount + 1,
            "CountryISOCode": "GB"
        }
        const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
            itemValue.ID === item.ID
                ? {
                    ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount + 1 }, PriceInfo: {
                        ...itemValue.PriceInfo,
                        BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount + 1),
                        TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount + 1)

                    }
                }
                : itemValue
        );
        dispatch(setOrderCartItems(updatedArray))
        updateCartItemQuantity(data).then((response) => {
            dispatch(setOrderData(response))
            setIsIncreasing(false)
            if (selectedVoucher) {
                setIsPrevLoading(false)
                setSelectedVoucher(null)

            }
            setIsItemLoading("")

        })
    }
    const decreaseQty = (item) => {
        setIsDeccreasing(true)
        setIsItemLoading(item.ID)
        let data = {
            "CartItemID": item.ID,
            "NewQuantity": item.Quantity.Amount - 1,
            "CountryISOCode": "GB"
        }
        if (data.NewQuantity > 0) {
            const updatedArray = restaurantDataState.orderCartData.Items.map((itemValue) =>
                itemValue.ID === item.ID
                    ? {
                        ...itemValue, Quantity: { ...itemValue.Quantity, Amount: item.Quantity.Amount - 1 }, PriceInfo: {
                            ...itemValue.PriceInfo,
                            BaseTotalPrice: updateTotalPrice(item.PriceInfo.BaseUnitPrice, item.Quantity.Amount - 1),
                            TotalPrice: updateTotalPrice(item.PriceInfo.UnitPrice, item.Quantity.Amount - 1),
                        }
                    }
                    : itemValue
            );
            dispatch(setOrderCartItems(updatedArray))
            updateCartItemQuantity(data).then((response) => {
                dispatch(setOrderData(response))
                setIsDeccreasing(false)
                setIsItemLoading("")

            })

        } else {
            let cartArray = restaurantDataState.orderCartData.Items.filter((cartItem) => cartItem.ID !== item.ID)
            dispatch(setOrderCartItems(cartArray))
            deleteCartItem(item.ID).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCartV3(customerID, cloud, "VOUCHER").then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    }
                    else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                    setIsItemLoading("")
                    setIsDeccreasing(false)
                }
            })
        }
    }
    const deleteItem = () => {
        if (isDeleteItem !== "") {
            deleteCartItem(isDeleteItem).then((response) => {
                if (response) {
                    if (restaurantDataState.orderCartData.Items.length > 1) {
                        let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
                        let cloud = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).cloudLocationID
                        getCartItemsToCartV3(customerID, cloud, "VOUCHER").then((response) => {
                            if (response) {
                                console.log(response, "response")
                                dispatch(setOrderData(response))
                            }
                        })
                        setIsDeleteItem("")
                    } else {
                        dispatch(setOrderEmpty())
                        setIsDeleteItem("")
                    }
                }
            })
        }
    }
    const renderLayout = (menuItem) => {
        const item = findItemFromCart(menuItem)
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img alt="" src={menuItem?.ImageURL ? menuItem.ImageURL : IMAGE_PLACEHOLDER}
                            className="item-image"
                        />
                        {menuItem?.MetaData?.IsDealProduct && <div className="dea-cont "> <img alt="" src={deal} className="deal" /></div>}
                        <div className="price-cont">
                            {getThePrice(menuItem?.PriceInfo?.Price)}
                        </div>
                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className="name">{menuItem?.Title?.en?.toCapitalFirst()}</div>
                        </div>

                        <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>
                        <div className="price-container">
                            <div className="price">
                                {getThePrice(menuItem?.PriceInfo?.Price)}
                            </div>
                            <div className='right-price-cont'>
                                <div className="preview-btn"
                                    onClick={() => {
                                        setSelectedVoucher(menuItem)
                                    }}>
                                    <img alt='' src={eye} />
                                    Preview
                                </div>
                                {item ?
                                    <div className="quantity">
                                        <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                            if (!isDecreasing && !isIncreasing) {
                                                decreaseQty(item)
                                            }
                                        }}>
                                            {item?.Quantity.Amount === 1 ? <img alt='' src={deleteIc} className='delete-icon' /> : <Icon name="minus" className="icon" />}
                                        </div>
                                        <div className="qty-cont">
                                            {item?.Quantity.Amount || 0}
                                        </div>

                                        <div className={!isDecreasing && !isIncreasing ? "icon-cont" : "empty-icon-cont"} onClick={() => {
                                            if (!isDecreasing && !isIncreasing) {
                                                increaseQty(item)
                                            }
                                        }}>
                                            <Icon name="plus" className="icon" />
                                        </div>
                                    </div> : <div className="add-to-cart-btn" onClick={() => {
                                        if (isLoading !== menuItem?.MenuItemID) {
                                            addItemToCart(menuItem)
                                        }
                                    }}>{isLoading === menuItem?.MenuItemID && !selectedVoucher ? < div className='loader-btn ' /> :
                                        <img alt='' src={cart} />
                                        }Add to cart</div>}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
    const getOrderType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
            case "table":
                type = "DINE_IN";
                break;
            case "collection":
                type = "TAKE_AWAY";
                break;
            default:
                type = "DELIVERY_BY_REWARDCONSUMER";
                break;
        }
        return type
    }
    const getItemPriceForCart = (option, quantity) => {
        const createPriceObj = (price, quantity) => ({
            Amount: price * quantity,
            FormattedText: currencyFormat((price * quantity) / 100),
            FormattedAmount: Number(((price * quantity) / 100).toFixed(2))
        });

        const getPriceData = (price, quantity) => ({
            Delivery: createPriceObj(price?.DeliveryPrice || 0, quantity),
            TakeAway: createPriceObj(price?.PickupPrice || 0, quantity),
            DineIn: createPriceObj(price?.TablePrice || 0, quantity),
            CurrencyCode: "GB"
        });

        const basePrice = getPriceData(option?.Price || {}, 1);
        const totalPrice = getPriceData(option?.Price || {}, quantity);
        return {
            BaseUnitPrice: basePrice,
            BaseTotalPrice: quantity > 1 ? totalPrice : basePrice
        };
    };
    const addItemToCart = async (selectedItem) => {
        let itemsAvailable = restaurantDataState.orderCartData?.Items?.some(itemVal => !itemVal?.MetaData && itemVal?.MetaData?.IsVoucher) ?? false;
        if (!itemsAvailable) {
            setIsPrevLoading(true)
            setIsLoading(selectedItem.MenuItemID)
            const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
            const userDetails = localStorage.getItem('fullUserDetails')
            let parsedUserDetails = JSON.parse(localStorage.getItem('fullUserDetails'))
            let customerID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
            let customer = {
                ID: customerID,
                Name: {
                    DisplayName: userDetails ? parsedUserDetails.UserName : "",
                    FirstName: userDetails ? parsedUserDetails.FirstName : "",
                    LastName: userDetails ? parsedUserDetails.LastName : "",
                },
                Email: userDetails ? parsedUserDetails.Email : "",
                IsPrimaryCustomer: true

            }
            let cartObject = {
                "CartItemID": selectedItem.MenuItemID,
                "Title": selectedItem.Title?.en,
                "CustomerID": customerID,
                "Quantity": {
                    "Unit": "pcs",
                    "Amount": 1
                },
                "DefaultQuantity": {
                    "Amount": 1,
                    "Unit": "pcs"
                },
                "CustomerRequests": {
                    "Allergy": {
                        "Allergens": [],
                        "Instructions": ""
                    },
                    "SpecialInstructions": ""
                },
                SelectedModifierGroups: [],
                Id: uuidv4(),
                ID: "",
                ModifierGroupRules: selectedItem.ModifierGroupRules,
                Image: selectedItem.ImageURL,
                PriceInfo: getItemPriceForCart(selectedItem.PriceInfo, 1),
                MetaData: {
                    IsVoucher: true,
                    Type: "STANDARD",
                    TemplateID: "",
                    ExpiryDate: "",
                    ProductID: selectedItem?.MetaData?.ProductID
                }

            }
            let cart = {
                "OrderID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_CART_ORDER_ID) : '',
                "StoreID": val.cloudLocationID,
                "ConsumerID": localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                "OrderingPlatformType": "RETAILPACX",
                "CountryISOCode": "GB",
                "OrganizationID": val.organizationID,
                "CloudLocationID": val.cloudLocationID,
                "Name": companyDetails.shopName,
                "OrderFullFilmentType": getOrderType(),
                "Customers": [customer],
                Cart: cartObject,
                OrderType: "VOUCHER"
            }
            await addToCart(cart).then((res) => {
                if (res) {
                    getCartItemsToCartV3(customerID, val.cloudLocationID, "VOUCHER").then((response) => {
                        if (response) {
                            dispatch(setOrderData(response))
                            setIsLoading("")
                            setIsPrevLoading(false)
                            setSelectedVoucher(null)
                            setIsOrderSuccess(true)

                        }
                    })
                } else {
                    setIsLoading("")
                    setIsPrevLoading(false)


                }
            }).catch(() => {
                setIsLoading("")
                setIsPrevLoading(false)
            })
        }
        else {
            setIsLoading("")
            setCartAlertVisible(true)
            setIsPrevLoading(false)

        }
    }

    useEffect(() => {
        if (data?.Categories?.length > 0) {
            const filteredItems = [];

            data.Categories.forEach((category) => {
                category.MenuEntities.forEach((menuEntity) => {
                    const menuItem = _.find(menuData?.data?.Items, { MenuItemID: menuEntity.ID });

                    if (menuItem?.MetaData?.CustomVoucher) {
                        filteredItems.push(menuItem);
                    }
                });
            });
            if (filteredItems.length > 0) {
                localStorage.setItem("ECOM_CUSTOM", JSON.stringify(filteredItems[0]))
            }
        }
    }, [data]);
    return (
        <div className="Voucher-navbar-LayoutVoucher">
            {data.Categories && data.Categories.length > 0 ? data.Categories.map((data, index) => {
                return (
                    <div key={index} style={{ marginBottom: "20px" }}>
                        <div className="layout2">
                            {data?.MenuEntities?.map(((menuEntity, key) => {
                                const menuItem = _.find(menuData.data.Items, { MenuItemID: menuEntity.ID });
                                if (!menuItem?.MetaData?.CustomVoucher && menuItem) {
                                    return (
                                        <div className="column-styles" key={key}>
                                            {renderLayout(menuItem)}
                                        </div>
                                    )
                                }
                            }))}
                        </div>
                    </div>
                )
            }) : <div className='empty-cont'>Vouchers not available</div>}

            <DeletePopup
                visibility={isDeleteItem !== ""}
                onPopupClose={() => {
                    setIsDeleteItem("")
                }}
                onDeleteConfirm={deleteItem} />
            <PreviewPopup
                visibility={selectedVoucher}
                onPopupClose={() => {
                    if (!isPrevLoading) {
                        setSelectedVoucher(null)
                    }
                }}
                onAdd={() => {
                    const item = findItemFromCart(selectedVoucher)
                    if (item) {
                        setIsPrevLoading(true)
                        increaseQty(item)
                    }
                    else if (selectedVoucher && !isPrevLoading) {
                        addItemToCart(selectedVoucher)
                    }
                }}
                isLoading={isPrevLoading} />
        </div >
    )
}
export default LayoutVoucher